// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1kaxV","emails":"CreateEditClinics_emails__2SYyy","emailTagLabel":"CreateEditClinics_emailTagLabel__3DgDN"};